import React, {ReactElement} from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography
} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import {useTranslation} from 'react-i18next';

interface ScheduleAppointmentChoiceDialogProps {
  open: boolean;
  onClose: () => void;
  onSelectAssistant: () => void;
  onSelectNormal: () => void;
  voiceAssistantShortCode?: string;
}

const useStyles = makeStyles(() => ({
  dialogActions: {
    display: 'flex',
    gap: '12px',
    padding: '16px'
  },
  actionButton: {
    flex: 1,
    minWidth: 0,
    height: '42px',
    fontSize: '1rem'
  }
}));

const ScheduleAppointmentChoiceDialog = (
  props: ScheduleAppointmentChoiceDialogProps
): ReactElement => {
  const {
    open,
    onClose,
    onSelectAssistant,
    onSelectNormal,
    voiceAssistantShortCode
  } = props;

  const {t} = useTranslation();
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      aria-labelledby="schedule-appointment-choice-dialog">
      <DialogTitle disableTypography>
        <Typography variant="h3" component="h2">
          {t(
            'APPOINTMENTS_SCHEDULAR_PORTAL.SCHEDULE_APPOINTMENT_CHOICE_TITLE'
          )}
        </Typography>
      </DialogTitle>

      <DialogContent dividers>
        <Typography variant="body1">
          {t(
            'APPOINTMENTS_SCHEDULAR_PORTAL.SCHEDULE_APPOINTMENT_CHOICE_SUBTITLE'
          )}
        </Typography>
      </DialogContent>

      <DialogActions className={classes.dialogActions}>
        <Button
          onClick={onClose}
          color="default"
          variant="outlined"
          className={classes.actionButton}>
          {t('COMMON.CANCEL')}
        </Button>

        <Button
          onClick={onSelectAssistant}
          color="primary"
          variant="outlined"
          disabled={!voiceAssistantShortCode}
          className={classes.actionButton}>
          {t('APPOINTMENTS_SCHEDULAR_PORTAL.BOOK_WITH_ASSISTANT')}
        </Button>

        <Button
          onClick={onSelectNormal}
          color="primary"
          variant="contained"
          className={classes.actionButton} style={{fontSize: '1rem', flex: 1, minWidth: 0, height: '42px'}}>
          {t(
            'APPOINTMENTS_SCHEDULAR_PORTAL.BOOK_APPOINTMENT_NORMAL'
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ScheduleAppointmentChoiceDialog;